module.exports = __webpack_public_path__ + "static/media/img4.adb0ca55.jpg";